<template>
  <div v-if="visible" class="modal-overlay" @click.self="close">
    <div class="login-box">
      <div class="form-tabs">
        <button type="button" class="glass-btn glass-btn--on-light glass-btn--sm" :class="isLogin ? 'glass-btn--active' : 'glass-btn--ghost'" @click="isLogin = true">登录</button>
        <button type="button" class="glass-btn glass-btn--on-light glass-btn--sm" :class="!isLogin ? 'glass-btn--active' : 'glass-btn--ghost'" @click="isLogin = false">注册</button>
      </div>

      <form @submit.prevent="handleSubmit" class="login-form">
        <div class="form-group">
          <label>邮箱</label>
          <input v-model="form.email" type="email" required placeholder="请输入邮箱" />
        </div>
        <div v-if="!isLogin" class="form-group">
          <label>用户名</label>
          <input v-model="form.username" type="text" required placeholder="请输入用户名" />
        </div>
        <div class="form-group">
          <label>密码</label>
          <input v-model="form.password" type="password" required placeholder="请输入密码" />
        </div>
        <div v-if="!isLogin" class="form-group">
          <label>验证码</label>
          <div class="code-row">
            <input v-model="form.code" type="text" required placeholder="请输入邮箱验证码" />
            <button type="button" class="glass-btn glass-btn--on-light glass-btn--ghost glass-btn--sm" :disabled="countdown > 0 || loading || !form.email" @click="getCode">
              {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
            </button>
          </div>
        </div>
        <button type="submit" class="glass-btn glass-btn--on-light glass-btn--block" :disabled="loading">{{ loading ? '处理中...' : (isLogin ? '登录' : '注册') }}</button>
        <div v-if="error" class="error">{{ error }}</div>
      </form>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/request.js'

export default {
  name: 'LoginModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  emits: ['update:visible', 'success'],
  data () {
    return {
      isLogin: true,
      loading: false,
      error: '',
      countdown: 0,
      timer: null,
      form: {
        email: '',
        username: '',
        password: '',
        code: '',
        sign: '',
        expires_at: 0
      }
    }
  },
  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    async handleSubmit () {
      this.loading = true
      this.error = ''
      try {
        if (this.isLogin) {
          const response = await api.auth.login({
            username: this.form.email,
            password: this.form.password
          })
          localStorage.setItem('token', response.data.access_token)
          const userResponse = await api.user.getMe()
          const username = userResponse.data.username
          localStorage.setItem('username', username)
          this.close()
          this.$emit('success', { username })
        } else {
          await api.auth.register({
            email: this.form.email,
            username: this.form.username,
            password: this.form.password,
            code: this.form.code,
            sign: this.form.sign,
            expires_at: this.form.expires_at
          })
          this.isLogin = true
          this.form.username = ''
          this.form.code = ''
        }
      } catch (err) {
        this.error = err.message || '操作失败'
      } finally {
        this.loading = false
      }
    },
    async getCode () {
      try {
        const resp = await api.auth.getSmsCode({ email: this.form.email })
        this.form.expires_at = resp.data.expires_at
        this.form.sign = resp.data.sign
        this.countdown = 120
        if (this.timer) clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.countdown -= 1
          if (this.countdown <= 0) {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      } catch (err) {
        this.error = err.message || '获取验证码失败'
      }
    }
  },
  beforeUnmount () {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--color-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-overlay);
  padding: var(--gap-lg);
  animation: fadeIn var(--duration-slow) ease;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.login-box {
  background: var(--surface-panel-strong);
  padding: 1.6rem 1.4rem;
  border-radius: var(--radius-modal);
  border: var(--border-width-control) solid var(--color-white-border);
  width: 100%;
  max-width: 340px;
  box-shadow: var(--shadow-modal);
  backdrop-filter: var(--backdrop-blur);
}
.form-tabs {
  display: flex;
  margin-bottom: 1.1rem;
  gap: var(--gap-xs);
  background: var(--surface-tabs);
  padding: 0.3rem;
  border-radius: var(--radius-md);
  border: var(--border-width-input) solid var(--surface-tabs-border);
}
.form-tabs button { flex: 1; }
.form-group { margin-bottom: var(--gap-md); }
.form-group label {
  display: block;
  margin-bottom: 0.3rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-text);
  font-size: 0.85rem;
}
.form-group input {
  width: 100%;
  padding: 0.6rem 0.8rem;
  border: var(--border-muted);
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  box-sizing: border-box;
  background: var(--surface-input);
}
.code-row { display: flex; gap: var(--gap-xs); }
.code-row input { flex: 1; }
.code-row button { white-space: nowrap; flex-shrink: 0; }
.login-form > button[type='submit'] {
  margin-top: 0.3rem;
  padding: 0.7rem;
}
.error {
  margin-top: var(--gap-md);
  padding: 0.6rem;
  background: var(--gradient-danger-bg);
  color: var(--color-danger);
  border: var(--border-width-input) solid var(--color-danger-border);
  border-radius: var(--radius-sm);
  text-align: center;
  font-size: 0.85rem;
}
</style>
